export const designShare = {
  schemeName: '方案名称',
  sharer: '分享人',
  shareTime: '分享时间',
  open: '打开'
};
